





























import _ from 'lodash';
import { defineComponent, onUnmounted, reactive, ref, computed, watch, nextTick } from '@vue/composition-api';
import { CloseIcon } from 'tdesign-icons-vue';

import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { Task } from '@/renderer/scripts/utils/TaskManager/types';
import ipc from '@/renderer/scripts/utils/ipc';
import listContent from './components/listContent.vue';
import transmissionListHandle from './transmissionListHandle';

export default defineComponent({
  components: {
    CloseIcon,
    listContent,
  },
  setup(props, context) {
    const tabValue = ref('upload');
    // eslint-disable-next-line max-len
    const { uploadList, downloadList, finishList, handleTransmissionOperate, handleFinishOperate } =
      transmissionListHandle();
    const showTrans = ref(false);
    const methods = {
      onAction(event: { command: string; actionType: string; task: Task<FileInfo> }) {
        const { command, actionType, task } = event;
        if (actionType === 'upload') {
          handleTransmissionOperate(command, task, 'upload');
        } else if (actionType === 'download') {
          handleTransmissionOperate(command, task, 'download');
        } else if (actionType === 'finish') {
          handleFinishOperate(command, task);
        }
      },
      transShow({ show, tab }: { show?: boolean; tab?: string }) {
        showTrans.value = show !== undefined ? show : true;
        tabValue.value = tab || tabValue.value;
      },
      transShowChange() {
        showTrans.value = !showTrans.value;
      },
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.TRANS_SHOW_CHANGE, methods.transShowChange);
    ipc.on(ipc.RENDERER_EVENTS_MAP.WEB_TRANS_SHOW, methods.transShow);
    onUnmounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.TRANS_SHOW_CHANGE, methods.transShowChange);
      ipc.off(ipc.RENDERER_EVENTS_MAP.WEB_TRANS_SHOW, methods.transShow);
    });
    return {
      tabValue,
      uploadList,
      downloadList,
      finishList,
      ...methods,
      showTrans,
    };
  },
});
